export const CANCEL_LABEL = 'Cancel';
export const API_KEY = 'BMPayAPIHCSCRetailPayments';
export const API_KEY_GPD_VMS = 'BMPayAPIHCSCVantagePayments';
export const API_KEY_GPD_TMG_MEDSUPP = 'BMPayAPIHCSCOver65Payments';
export const API_KEY_GPD_MT_TMG_MEDSUPP = 'BMPayAPIHCSCMontanaPayments';
export const API_KEY_GPD_TMG_PDP = 'BMPayAPIHCSCPDPPayments';
export const API_KEY_GPD_TMG_MAPD = 'BMPayAPIHCSCMAPDPayments';

export enum ALERT_TYPES {
  INFORMATION = 'information',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

export const CURRENCY_DOLLAR = '$';

interface ICommonConstantsProps {
  [key: string]: ICommonObjectProps;
}

export interface ICommonObjectProps {
  [key: string]: string;
}

interface ICustomerServiceNumber {
  [key: string]: string;
}

export const COMMON_CONSTANTS: ICommonConstantsProps = {
  fieldProps: {
    className: 'className',
    value: 'value',
    label1: 'label1',
    label2: 'label2',
    testId: 'testId',
  },
};

export const FUNDING_TOKEN_SUCCESS_STATUS_CODE = 'Created';

export const LOADING_SCREEN_MESSAGE = 'Loading...';

export const API_ROUTE_STATE_CODE_PLACEHOLDER = '##STATE_CODE##';

export const CUSTOMER_SERVICE_NUMBER: ICustomerServiceNumber = {
  IL: '800-538-8833',
  MT: '855-258-8471',
  OK: '866-520-2507',
  TX: '888-697-0683',
  NM: '866-236-1702',
};

export const PRODUCER_SERVICE_NUMBER: ICustomerServiceNumber = {
  IL: '888-313-5526',
  MT: '855-454-7109',
  OK: '888-399-9394',
  TX: '888-697-0679',
  NM: '888-222-0572',
};

export const stateCodes = ['IL', 'MT', 'OK', 'TX', 'NM'];

export const SESSION_TIME = 15 * 60 * 1000; // 15 minutes
export const SESSION_TIMOUT_DIALOG_TIME = 2 * 60 * 1000; // 2 minutes
export const SESSION_TIMER_DIALOG_TIMER_PLACEHOLDER = '${TIMER}';
export const HELPDESK_NUMBER_PLACEHOLDER = '$helpdesknumber';
export const CUSTOMER_SERVICE_NUMBER_PLACEHOLDER = '$customerservice';
export const PLAN_NAME_PLACEHOLDER = '$plan name';
export const CUSTOMER_SERVICE_NUMBER_PLACEHOLDER_NEW = '{{ custService }}';
export const CUSTOMER_SERVICE_NUMBER_PLACEHOLDER_CAMELCASE = '$customerService';
export const CUSTOMER_SERVICE_NUMBER_WITH_PLACEHOLDER_X = 'XXX-XXX-XXXX';
export const PRODUCER_SERVICE_NUMBER_PLACEHOLDER = '$producerservice';
export const MEDICARE_LINK_TEXT = 'Medicare payment options';
export const MEDICARE_LINK = `$${MEDICARE_LINK_TEXT}`;
export const ERROR_CODE = '$error code';
export const ERROR_CODE1 = '$errorcode';
export const COUNT_PLACEHOLDER = '{{ count }}';
export const TOTAL_COUNT_PLACEHOLDER = '{{ totalCount }}';
export const PAGINATION_PAGE_NO = '$#page';
export const PAGINATION_TOTAL_PAGE_NO = '$#totalPages';
export const BINDER_PAY_NOW_CONFIRMATION_NUMBER = '$confirmationnumber';

export const PAGINATION_PER_PAGE_SIZE = 10;
export const PAGINATION_INITIAL_PAGE_NO = 1;

export const PAGINATION_VIEW = 'PAGINATION_VIEW';
export const PAGINATION_DATA = 'PAGINATION_DATA';
export const START_DATE = '$startdate';
export const END_DATE = '$enddate';
export const EMPTY_HISTORY_FILTER_RESULTS = '0';

export const NEXT_MONTH = '$next month';
export const THIS_MONTH = '$this month';

export enum PAYMENT_FAILED_ERROR_TYPE {
  PAYMENT_FAILED = 'paymentFailed',
  PAYMENT_AUTHORIZATION_ERROR = 'paymentError',
  CA_AUTHORIZATION_TERMINATED_ERROR = 'caTerminatedAccError',
  CA_AUTHORIZATION_DEPENDENT_ERROR = 'caDependentError',
  MEMBER_LOOKUP_ERROR = 'memberLookupError',
}

export const SUPPORTED_BROWSERS: { [key: string]: any } = {
  Chrome: {
    MINIMUM_SUPPORTED_VERSION: 79,
  },
  Firefox: {
    MINIMUM_SUPPORTED_VERSION: 78,
  },
  Safari: {
    MINIMUM_SUPPORTED_VERSION: 13,
  },
  IE: {
    MINIMUM_SUPPORTED_VERSION: 11,
  },
  Edge: {
    MINIMUM_SUPPORTED_VERSION: 92,
  },
  Opera: {
    MINIMUM_SUPPORTED_VERSION: 77,
  },
  WebKit: {
    MINIMUM_SUPPORTED_VERSION: 600,
  },
};

export const DEVICE_TYPE = {
  DESKTOP: 'Desktop',
  MOBILE: 'Mobile',
};

export enum DELETE_WALLET_ERROR_TYPES {
  AUTO_PAYMENT_REFERENCE = 'autoPaymentReferenceFound',
  RECURRING_PAYMENT_REFERENCE = 'recurringPaymentReferenceFound',
  SCHEDULED_PAYMENT_REFERENCE = 'scheduledPaymentReferenceFound',
  AUTO_AND_SCHEDULED_PAYMENT_REFERENCE = 'autoAndScheduledPaymentReferenceFound',
}

export enum SERVICE_TYPE {
  MMA = 'hcsc-members-mma-mfa',
  NMA = 'hcsc-memberauth-nma-mfa',
}

export enum USER_TYPES {
  GUEST = 1,
  ONE_TIME_PAYMENT_ACTIVE_MEMBER = 2,
  BAM_PUBLICSITE_ACTIVE_MEMBER = 5,
  BINDER_MEMBER = 4,
  CUSTOMER_ADVOCATE = 3,
  GOVERNMENT_GUEST = 6,
  ONE_TIME_GOVERNMENT_ACTIVE_MEMBER = 7,
  CA_TERMED_MEMBER = 8,
  BAM_GOVERNMENT_ACTIVE_MEMBER = 9,
  NMA_IFM_USER = 10,
  NMA_GOVT_USER = 11,
  CA_GOVT_USER = 12,
  BROKER = 13,
}

export enum ORIGIN_TYPES {
  BAM = 'bam',
  PUBLICSITE = 'publicsite',
  MMA = 'mma',
  UMA = 'uma',
  GUEST = 'guest',
  BINDER_PAY_NOW = 'binderpaynow',
  BINDER_PAY_LATER = 'binderpaylater',
  CA = 'ca',
  CA_GOVT_USER = 'cagovernmentactive',
  CA_BINDER_PAY_LATER = 'cabinderpaylater',
  GUEST_GOVERNMENT = 'guestgovernment',
  ONE_TIME_GOVERNMENT_ACTIVE = 'onetimegovernmentactive',
  BAM_GOVERNMENT_ACTIVE = 'bamgovernmentactive',
  CA_TERMED_MEMBER = 'catermedmember', //this origin type is only being used in protected routes for route guarding
  NMA = 'nma',
  BROKER = 'broker',
}

export const USER_TYPE_STRING = {
  GUEST: 'GUEST',
  ACTIVE_MEMBER: 'ACTIVE_MEMBER',
  BAM_PUBLICSITE_ACTIVE_MEMBER: 'BAM_PUBLICSITE_ACTIVE_MEMBER',
  BINDER_PAY_LATER: 'BINDER_PAY_LATER',
  BINDER_PAY_NOW: 'BINDER_PAY_NOW',
  CUSTOMER_ADVOCATE: 'CUSTOMER_ADVOCATE',
  CA_BINDER_PAY_LATER: 'CA_BINDER_PAY_LATER',
  GOVT_GUEST: 'GOVT_GUEST',
  GOVT_ACTIVE: 'GOVT_ACTIVE',
  NMA_IFM_MEMBER: 'NMA_IFM_MEMBER',
  GOVT_BAM: 'GOVT_BAM',
  NMA_GOVT: 'NMA_GOVT',
  BROKER: 'BROKER',
};

export enum PAGINATION_EVENT_TYPE {
  SELECT_PAGE = 'select_page',
  NEXT_PAGE = 'next_page',
  PREVIOUS_PAGE = 'previous_page',
}

export enum BINDER_TYPES {
  PAY_NOW = 'pay-now',
  PAY_LATER = 'pay-later',
}

export enum MEMBER_ELB_AUTHENTICATION_ERROR_CODES {
  ERR103 = 'ERR103',
  ERR010 = 'ERR010',
  ERR301 = 'ERR301', // online payment not available
}

export enum VALIDATE_MEMBER_ERROR_CODES {
  ERR211 = 'ERR211', // no hps match account or rsts api failed
  ERR001 = 'ERR001', // member search api failed
  ERR009 = 'ERR009', // no active policies
  ERR010 = 'ERR010', // termed policy
  ERR203 = 'ERR203', // no active policies
}

export enum CA_AUTHENTICATION_ERROR_CODES {
  ERR010 = 'ERR010', //  Terminated Account Error code
  ERR011 = 'ERR011', // Dependnet member Error code
  ERR303 = 'ERR303', // Government CA Medsupp Termed Member Error Code
}

export enum VALIDATE_BROKER_ERROR_CODES {
  ERRBP01 = 'ERRBP01', // Details unavailable in broker url
}

export enum VALIDATE_ERROR_CODES {
  ERR503 = '503', //  Service Unavailable
  ERR009 = 'ERR009',
  ERR137 = 'FIS137', // payment blocked
}

export enum SCHEDULE_MAINTENANCE_APPLICATION_TYPES {
  PAY_NOW = 'mpp-binder-payNow-flow',
  PAY_LATER = 'mpp-binder-payLater-flow',
  MEMBER = `mpp-member-flow`,
}

export enum MPP_AUTOPAY_ENROLLMENT_MODAL_STATUS {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
}

export enum ONBOARD_CONVERSION_TYPES {
  CONVERSION = 'CONVERSION',
  FORCED_CONVERSION = 'FORCED CONVERSION',
}

export enum MEMBER_CONVERSION_TYPES {
  FORCED_CONVERSION_WITH_AUTOPAY = 'FORCED_CONVERSION_WITH_AUTOPAY',
  FORCED_CONVERSION_WITHOUT_AUTOPAY = 'FORCED_CONVERSION_WITHOUT_AUTOPAY',
  FORCED_CONVERSION = 'FORCED_CONVERSION',
  AP_FORCED_CONVERSION = 'AP_FORCED_CONVERSION', // here autopay is force converted through backend batch process
}

export const TEXT_COLOR = {
  colorTextLight: 'light',
  colorTextDark: 'dark',
};

export enum PLAN_TYPES {
  RETAIL = 'RETAIL',
  GOVERNMENT = 'GOVERNMENT',
  NA = 'NA',
}

export const AUTOPAY_ON = 'ON';
export const AUTOPAY_NA = 'N/A';
